import { createFeatureSelector, createSelector } from '@ngrx/store';
import {GroupState} from "./group.state";
import {SchoolGroupStatus} from "@core/models/domain/group.domain";

export const selectGroupState = createFeatureSelector<GroupState>('group');

export const selectAllGroups = createSelector(
    selectGroupState,
    (state) => state.groups
);

// Memoized list view: ACTIVE groups only, computed once per state change.
export const selectActiveGroups = createSelector(
    selectAllGroups,
    (groups) => groups.filter(group => group.status === SchoolGroupStatus.ACTIVE)
);

export const selectGroupLoading = createSelector(
    selectGroupState,
    (state) => state.loading
);

// True once groups are loaded, or the last load failed: nothing more is coming for now.
export const selectGroupsSettled = createSelector(
    selectGroupState,
    (state) => state.loaded || !!state.error
);

export const selectGroupError = createSelector(
    selectGroupState,
    (state) => state.error
);

// If you want a selector for a single group by ID:
export const selectGroupById = (id: string) =>
    createSelector(selectAllGroups, groups => groups.find(g => g.id === id));